import React, { useEffect, useRef, useState } from "react"

export default () => {
    const [logStat, setLogStat] = useState(null);
    const [userId, setUserId] = useState("0");
    const hoverRef = useRef(false);
    const divRef = useRef(null);
    useEffect(() => {
        let k = setInterval(() => {
            fetch(`/devLogStat?userId=${userId}`)
            .then(res => res.json())
            .then(res => {
                setLogStat(res);
                !hoverRef.current && divRef.current && (divRef.current.scrollTop = divRef.current.scrollHeight);
            });
        }, 1000);
        const blur = () => {
            clearInterval(k);
        }
        const focus = () => {
            clearInterval(k);
            k = setInterval(() => {
                fetch(`/devLogStat?userId=${userId}`)
                .then(res => res.json())
                .then(res => {
                    setLogStat(res);
                    !hoverRef.current && divRef.current && (divRef.current.scrollTop = divRef.current.scrollHeight);
                });
            }, 1000);
        }
        window.addEventListener("blur", blur);
        window.addEventListener("focus", focus);
        return () => {
            window.removeEventListener("blur", blur);
            window.removeEventListener("focus", focus);
            clearInterval(k);
        }
    }, [userId]);
    return (
        <div>
            {logStat ? <>
                <button onClick={() => {
                    fetch(`/devLogStat?logRequests=${logStat.logRequests ? "0" : "1"}`)
                    .then(res => res.json())
                    .then(res => {
                        setLogStat(res);
                    });
                }}>{logStat.logRequests ? "turn off" : "turn on"}</button>
            </> : null}
            <p>Log</p>
            <input
                value={userId}
                onChange={(event) => {
                    setUserId(event.target.value);
                }}
            />
            <pre
                ref={(nestedElement) => {
                    divRef.current = nestedElement;
                    !hoverRef.current && divRef.current && (divRef.current.scrollTop = divRef.current.scrollHeight);
                }}
                onMouseOver={() => {
                    hoverRef.current = true;
                }}
                onMouseLeave={() => {
                    hoverRef.current = true;
                }}
                style={{maxHeight: "80vh", overflow: "auto"}}
            ><code>
                {logStat?.log}
            </code></pre>
        </div>
    )
}